:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  :host {
    padding: 0;
  }
}

@media screen and (max-width: 979px) {
  .specifications__collapsible-container {
    padding: 0 16px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 979px) {
  .specifications__heading {
    margin: 20px 0;
  }
}

.specifications__content {
  margin: 0 -16px;
}

.specifications__view-more-content-wrapper {
  max-height: 90vh;
  position: relative;
  overflow: hidden;
}

.specifications__view-more-content-wrapper--expanded {
  max-height: none;
}

.specifications__view-more-content--minimized::before {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
}

:host(:not([dir="rtl"])) .specifications__view-more-content--minimized::before {
  left: 0;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}

:host([dir="rtl"]) .specifications__view-more-content--minimized::before {
  right: 0;
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}

.specifications__view-more-wrapper {
  text-align: center;
}